import {createSelector, ParametricSelector} from 'reselect';

import {canSplitMessage} from '../../../../helpers/models/messageHelpers';
import {ConversationModel} from '../../../../models/api/conversationModel';
import {MessageModel} from '../../../../models/api/messageModel';
import {AppState} from '../../../appState';
import {makeGetReplyChannel} from '../../../data/channels/channelsSelectors';

type GetOptionalConversation = ParametricSelector<AppState, any, ConversationModel | undefined>;
type GetMessage = ParametricSelector<AppState, any, MessageModel>;

export function makeGetCanSplitMessage(getConversation: GetOptionalConversation, getMessage: GetMessage) {
  return createSelector(
    [getMessage, getConversation],
    (message, conversation) => (conversation && canSplitMessage(message, conversation)) || false,
  );
}

type GetSelectedInboxId = ParametricSelector<AppState, any, number | undefined>;

export function makeGetShowReplyAction(getMessage: GetMessage, getSelectedInboxId: GetSelectedInboxId) {
  const getReplyChannel = makeGetReplyChannel({
    getMessage,
    getSelectedInboxId,
  });

  return createSelector(getReplyChannel, (replyChannel) => Boolean(replyChannel));
}
